/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'

const About = ({
    image,
    title,
    children,
}) => (
    <div className="about-wrapper">
        <div className="about-about" id="about">
            <div className="about-image">
                <img
                    src={image}
                    alt="Eight people surrounding a computer."
                    width="100%"
                    height="auto"
                />
            </div>
            <div className="about-description">
                <h3 className="about-title">
                    About
                    {' '}
                    {title}
                </h3>
                {children}
            </div>
        </div>
    </div>
)

About.propTypes = {
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.objectOf(PropTypes.any).isRequired,
}

export default About
